import script from "./ComputedProperties.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputedProperties.vue?vue&type=script&lang=ts&setup=true"

import "./ComputedProperties.vue?vue&type=style&index=0&id=8c421684&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c421684"]])

export default __exports__